import gsap from 'gsap'

export const afterTransition = () => {
  console.log('afterTransition')
  document.fonts.ready.then(() => {
    const anim = {
      masks: document.querySelectorAll('[data-animate-mask]'),
      linesParent: document.querySelectorAll('[data-animate-mask-lines]'),
      lines: document.querySelectorAll('[data-animate-mask-lines] .line'),
      swipe: document.querySelectorAll('[data-animate-swipe]'),
      fade: document.querySelectorAll('[data-animate-fade]')
    }

    anim.masks.forEach((mask) => {
      const words = mask.querySelectorAll('.word')
      gsap.to(words, {
        duration: 1.6,
        y: 0,
        x: 0,
        stagger: 0.04,
        rotate: '0deg',
        ease: 'power3.inOut'
      })
    })

    const tl = gsap.timeline()

    anim.lines.forEach((line, i) => {
      const words = line.querySelectorAll('.word')
      if (i == 0) {
        tl.to(words, { duration: 1.6, y: 0, x: 0, ease: 'power3.inOut' })
      } else {
        tl.to(words, { duration: 1.6, y: 0, x: 0, ease: 'power3.inOut' }, '-=1.5')
      }
    })

    if (anim.fade.length) {
      gsap.fromTo(
        anim.fade,
        { opacity: 0 },
        { duration: 1.2, delay: 0.8, opacity: 1, ease: 'power1.out' }
      )
    }

    if (anim.swipe.length) {
      gsap.fromTo(
        anim.swipe,
        { clipPath: 'inset(100% 0 0 0)' },
        { duration: 1.2, delay: 0.4, clipPath: 'inset(0% 0 0 0)', ease: 'power2.out' }
      )
    }
  })
}

export default () => {}
